import { InputHTMLAttributes } from 'react'
import { useFormContext } from 'react-hook-form'

import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'
import { translate } from '@/utils/translator'

import { FormValues } from '../../schema'

type FormInputProps = InputHTMLAttributes<HTMLInputElement> & {
	name: keyof FormValues
	label: string
	error?: string
	required?: boolean
}

export const FormTextInput = ({
	name,
	label,
	required,
	error,
	className,
	onBlur,
	...rest
}: FormInputProps) => {
	const { register } = useFormContext<FormValues>()

	return (
		<label className={cn('flex flex-col gap-8')}>
			<Typography style={'p'} element="p">
				{`${label} ${required ? '*' : ''}`}
			</Typography>
			<input
				{...rest}
				{...register(name)}
				className={cn(
					'w-full rounded-8 border border-userData-textMobile bg-userData-bgSecondary p-16  disabled:opacity-75 md:border-userData-text md:bg-naturel',
					error && '!border-danger',
					className
				)}
				onBlur={onBlur}
			></input>
			<div className={cn('h-12 text-danger')}>
				{error && (
					<Typography style={'p-s-bold'} element="p">
						{translate(error)}
					</Typography>
				)}
			</div>
		</label>
	)
}
